"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/inspiroidu-oluesta/inspiroidu-oluesta.scss');
//import { Init, InitReact, ImportCoreweb } from './index';
const index_1 = require("./index");
const inspiroidu_oluesta_1 = require("./../js/Sites/inspiroidu-oluesta");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, inspiroidu_oluesta_1.InitInspiroiduOluesta)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
//InitReact();
